import { collapseSection, expandSection } from '../src/Helpers';

export default {
  props: {
    defaultTab: {
      type: String,
      default: null,
    },

    items: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      currentTab: this.defaultTab,
    };
  },

  computed: {
    currentLabel() {
      let items = Object.values(this.items);
      let current_item = items.find((item) => {
        return item.row_id === this.currentTab;
      });

      return current_item.row_label;
    },
  },

  mounted() {
    this.checkUrl();

    window.addEventListener(
      'hashchange',
      () => {
        this.checkUrl(true);
      },
      false
    );
  },

  methods: {
    checkUrl(collapseMenu = false) {
      // If there is a hash in the URL on page load then use that as the default
      // tab. There is the possibility that someone would provide an invalid hash.
      // However while this would look incorrect, clicking a tab would then fix
      // it. I tried applying the ID to the tab and then checking if it exists
      // but then it scrolls down to the tab, which is not desirable. I think this
      // is good enough for now.
      let id = window.location.hash.replace('#', '');

      if (id) {
        this.currentTab = id;
      }

      if (collapseMenu) {
        this.closeMenu();
      }
    },

    isActive(tabName) {
      return this.currentTab === tabName;
    },

    closeMenu() {
      let expandButton = this.$el.querySelector('.expand-button');
      let mobileSubNavMenu = this.$el.querySelector('.expand-list');

      collapseSection(mobileSubNavMenu);
      expandButton.classList.remove('is-active');
    },

    toggleMobileSubNavMenu() {
      let expandButton = this.$el.querySelector('.expand-button');
      let mobileSubNavMenu = this.$el.querySelector('.expand-list');

      if (!expandButton.classList.contains('is-active')) {
        expandSection(mobileSubNavMenu);
        expandButton.classList.add('is-active');
      } else if (expandButton.classList.contains('is-active')) {
        collapseSection(mobileSubNavMenu);
        expandButton.classList.remove('is-active');
      }
    },
  },

  render() {
    return this.$scopedSlots.default({
      currentTab: this.currentTab,
      currentLabel: this.currentLabel,
      isActive: this.isActive,
      toggleMobileSubNavMenu: this.toggleMobileSubNavMenu,
    });
  },
};
